import * as React from 'react';
import { useEffect } from "react";
import { _PortalState } from './helpers/state';
import Menu from './Menu';
import * as microsoftTeams from "@microsoft/teams-js";
import { useTeams } from 'msteams-react-base-component';
import { Route, Switch } from 'react-router-dom';
import { Innovation } from './components/innovation/Innovation';
import { TabConfig } from './components/tabconfig/TabConfig';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools'


//ngrok http --region=eu --hostname=bw.eu.ngrok.io 3000

// const config: Configuration = {
//     auth: {
//         authority: 'https://bwventuresb2c.b2clogin.com/bwventuresb2c.onmicrosoft.com/B2C_1_signin_signup_2',
//         clientId: 'c9355c92-83d4-4682-9240-6ef88b03712f',
//         redirectUri: window.location.origin,
//         knownAuthorities: ["bwventuresb2c.b2clogin.com"]
//     },
//     cache: {
//         // cacheLocation: "localStorage",
//         storeAuthStateInCookie: true
//     },

// };

// export const loginRequest: RedirectRequest = {
//     scopes: ["https://bwventuresb2c.onmicrosoft.com/portal/api_access"]
//     // scopes: [ "openid", "offline_access" ]
// };

// // const authenticationParameters = {
// //     scopes: [
// //         'https://bwventuresb2c.onmicrosoft.com/portal/api_access'
// //     ]
// // }

const Main = () => (
  <Switch>
    {/* <Route exact={true} path='/' component={HomePage} /> */}
    {/* <Route exact={true} path='/video' component={Videos} /> */}
    {/* <Route exact={true} path='/video/:id' component={Video} /> */}
    <Route exact={true} path='/innovation' component={Innovation} />
    <Route exact={true} path='/tabconfig' component={TabConfig} />
    {/* <Route exact={true} path='/innovation/:group/canvas' component={Canvas} /> */}
  </Switch>
);


export const App: React.FC = () => {

  const [{ inTeams, theme, context }] = useTeams();

  _PortalState.ApiEndpoint = "https://bwteamsapi.azurewebsites.net/api";

  useEffect(() => {
    if (inTeams === true) {
      microsoftTeams.initialize(() => {
        microsoftTeams.authentication.getAuthToken({
          successCallback: (token: string) => {
            // console.log(context);
            // const decoded: { [key: string]: any; } = jwtDecode(token) as { [key: string]: any; };
            // setName(decoded!.name);
            if (context)
              _PortalState.teamsContext = context;
            microsoftTeams.appInitialization.notifySuccess();
          },
          failureCallback: (message: string) => {
            // setError(message);
            microsoftTeams.appInitialization.notifyFailure({
              reason: microsoftTeams.appInitialization.FailedReason.AuthFailed,
              message
            });
          },
          resources: ['api://teams.bwventures.nl/ce26c9a9-a8e6-4068-a53a-eb1cc0969808/access_as_user'] //[process.env.CANVAS_APP_URI as string]
        });
      });
    } else {
      // setEntityId("Not in Microsoft Teams");
      microsoftTeams.appInitialization.notifyFailure({
        reason: microsoftTeams.appInitialization.FailedReason.Other
        // "Not in Microsoft Teams"
      });
    }
  }, [inTeams]);

  if (context) {
    _PortalState.teamsContext = context;
    return (
      <Portal />
    )
  }
  else return <div></div>

  // constructor(props: {}) {
  //     super(props);
  //     this.state = {
  //         LoggedIn: false
  //     }

  //     _PortalState.authProvider = new PublicClientApplication(config); //new MsalAuthProvider(config, authenticationParameters, LoginType.Redirect)
  //     // _PortalState.authProvider.handleRedirectPromise()
  //     //     .then((response: any) => {
  //     //         console.log(response);
  //     //     })
  //     //     .catch(error => {
  //     //         console.log(error);

  //     //         // Check for forgot password error
  //     //         // Learn more about AAD error codes at https://docs.microsoft.com/en-us/azure/active-directory/develop/reference-aadsts-error-codes
  //     //         if (error.errorMessage.indexOf("AADB2C90118") > -1) {
  //     //             // try {
  //     //             //     _PortalState.authProvider.loginRedirect({"https://bwventuresb2c.b2clogin.com/bwventuresb2c.onmicrosoft.com/B2C_1_reset_password_2");
  //     //             // } catch(err) {
  //     //             //     console.log(err);
  //     //             // }
  //     //         }
  //     //     });
  //     _PortalState.ApiEndpoint = "https://bwventures-api.azurewebsites.net";
  //     // _PortalState.ApiEndpoint = 'https://bwventuresportal-api.azurewebsites.net';
  // }


  // public render() {
  //     console.log(_PortalState.authProvider.getAllAccounts());

  //     return (
  //         // <AzureAD
  //         //     provider={
  //         //         _PortalState.authProvider
  //         //     }
  //         //     forceLogin={true}
  //         // >
  //         //     <Portal />
  //         // </AzureAD>
  //         <MsalProvider instance={new PublicClientApplication(config)}>
  //             <UnauthenticatedTemplate>
  //                 <Button onClick={() => _PortalState.authProvider.loginRedirect(loginRequest)}>Login</Button>
  //             </UnauthenticatedTemplate>
  //             <AuthenticatedTemplate>
  //                 <Portal />
  //             </AuthenticatedTemplate>
  //         </MsalProvider>
  //     );

  // }
}

class Portal extends React.Component<{}, any> {

  // constructor(props: any) {
  //   super(props);
  //   // this.state = {
  //   //   LoggedIn: false
  //   // }
  // }


  public async componentDidMount() {
    //   _PortalState.authProvider.acquireTokenSilent(
    //     {
    //       scopes: ["https://bwventuresb2c.onmicrosoft.com/portal/api_access"],
    //       account: _PortalState.authProvider.getAllAccounts()[0],
    //     }
    //   ).then(token => {
    //     // console.log(token.accessToken);
    //     fetch(_PortalState.ApiEndpoint + '/api/groups', {
    //       method: 'GET',
    //       headers: {
    //         'Authorization': 'Bearer ' + token.accessToken
    //       }
    //     })
    //       .then(res => res.json())
    //       .then(groups => {
    //         // _PortalState.groups = groups.groups;
    //         // this.setState({ LoggedIn: true });
    //         fetch('/videos.json')
    //           .then(res => res.json())
    //           .then(videos => {
    //             _PortalState.groups = groups.groups;
    //             _PortalState.videos = videos['videos'];
    //             this.setState({ LoggedIn: true });
    //           });
    //       })
    //   })

  }



  public render() {
    // if (this.state.LoggedIn) {
    //   return (
    //     <Menu />
    //   );
    // } else {
    const queryClient = new QueryClient()
    return (
      <div>
        <QueryClientProvider client={queryClient}>
          <Main />
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
        {/* {_PortalState.teamsContext.groupId} */}
        {/* <Loading /> */}
      </div>
    )
  }
}
// }
